




































































import Vue from 'vue';
import Component, { mixins } from 'vue-class-component';
import BackgroundColorClass from '@/common/ts/background-color/BackgroundColorMixin';
import i18n from './i18n';

const BrandhubIcon = () => import('@/webcomponents/brandhub-icon/Icon.vue');

const FootnotesProps = Vue.extend({
  props: {
    editMode: Boolean,
    showIconsLegend: Boolean,
    nefz2: Boolean,
    nefz1: Boolean,
    wltp: Boolean,
    provisionalNefz2: Boolean,
    provisionalWltp: Boolean,
    vo6922008Eg: Boolean,
    provisionalElectric: Boolean,
    provisionalAll: Boolean,
    datDe: Boolean,
  },
});

@Component({
  components: {
    BrandhubIcon,
  },
  i18n,
})
export default class Footnotes extends mixins(FootnotesProps, BackgroundColorClass) {
  get rootClasses () {
    return {
      'brandhub-footnotes--edit-mode': this.editMode,
    };
  }
}
